
import {Inject, inject, Injectable, DOCUMENT} from '@angular/core';
import {MastheadUserMenuConfig} from '@app/services/navigation/model/masthead-user-menu-config.model';
import {DcpApiService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BaseSiteService, User} from '@spartacus/core';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

export interface LoggedInUser {
  name: string;
  email: string;
  avatarInitials: string;
  avatarUrl: string;
}

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class HeaderUserMenuService {
  private dcpApiService = inject(DcpApiService);
  private userFacade = inject(UserAccountFacade);
  private loggedInUserSubject = new BehaviorSubject<LoggedInUser>(null);
  private baseSiteService = inject(BaseSiteService);
  public showCountrySelector = true;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  getUserData(): Observable<any> {
    this.userFacade
      .get()
      .pipe(untilDestroyed(this))
      .subscribe((user: User) => {
        if (user) {
          this.showCountrySelector = false;
          const loggedInUser: LoggedInUser = {
            name: user.name,
            email: user.email,
            avatarInitials: this.extractInitials(user.name),
            avatarUrl: 'https://avatars.profile.sap.com/images',
          };
          this.loggedInUserSubject.next(loggedInUser);
        }
      });
    return this.loggedInUserSubject.asObservable();
  }

  extractInitials(name: string): string {
    if (!name) {
      return '';
    }
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  }

  getUserMenuConfig(): Observable<any> {
    return combineLatest([
      this.dcpApiService.callApi<MastheadUserMenuConfig>('commerceUiAssets', 'mastheadUserMenuConfig'),
      this.baseSiteService.getActive(),
    ]).pipe(
      distinctUntilChanged(),
      map(([userMenuConfig, baseSite]) => {
        let transformedConfig = [
          {
            items: userMenuConfig.items.map((item) => ({
              title: item.title,
              url: item.url,
            })),
          },
        ];
        transformedConfig[0].items.push({
          title: 'My Shopping Cart',
          url: `${this.document.location.origin}/${baseSite}/cart`,
        });
        return transformedConfig;
      })
    );
  }
}
